import {get} from 'lodash/fp';
import {createSelector} from 'reselect';

import {auth as authState} from './root.selector';

export const authCredentials = createSelector(authState, get('credentials'));

export const credentialsEmail = createSelector(authCredentials, get('email'));
